import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { services, baldivisServices, joondalupServices, leedervilleServices } from "../Data";

const SearchSection = () => {

  // CONTAINER STAGGER
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.16,
      },
    },
  };

  // PREMIUM FADE UP
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 45,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  // SUBURB ANIMATION
  const suburbVariant = {
    hidden: {
      opacity: 0,
      y: 18,
    },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.06,
        duration: 0.55,
        ease: [0.22, 1, 0.36, 1],
      },
    }),
  };

const suburbs = [
  {
    name: "Perth",
    link: "/services",
  },
  {
    name: "Baldivis",
    link: "/services/baldivis",
  },
  {
    name: "Joondalup",
    link: "/services/joondalup",
  },
  {
    name: "Leederville",
    link: "/services/leederville",
  },
  {
    name: "Leederville",
    link: null,
  },
  {
    name: "Shenton Park",
    link: null,
  },
  {
    name: "Cottesloe",
    link: null,
  },
  {
    name: "Fremantle",
    link: null,
  },
];

  const navigate = useNavigate();

const [searchTerm, setSearchTerm] =
  useState("");

const searchableServices = [
  ...services.map((service) => ({
    ...service,
    location: "",
    path: `/services/${service.slug}`,
  })),

  ...baldivisServices.map((service) => ({
    ...service,
    location: "Baldivis",
    path: `/services/baldivis/${service.slug}`,
  })),

    ...joondalupServices.map((service) => ({
    ...service,
    location: "Joondalup",
    path: `/services/joondalup/${service.slug}`,
  })),

   ...leedervilleServices.map((service) => ({
    ...service,
    location: "Leederville",
    path: `/services/leederville/${service.slug}`,
  })),
];

const filteredServices =
  searchTerm.trim() === ""
    ? []
    : searchableServices.filter((service) => {
        const searchText = `
          ${service.title}
          ${service.location}
        `.toLowerCase();

        return searchText.includes(
          searchTerm.toLowerCase()
        );
      });

  return (
    <section className="search-section">

      <motion.div
        className="container search-container"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.25,
        }}
      >

        {/* TITLE */}
        <motion.h2 variants={fadeUp}>
          Find Settlement Services Near You
        </motion.h2>

        {/* DESC */}
        <motion.p variants={fadeUp}>
          Search by suburb to see how we can help
          with your property journey
        </motion.p>

        {/* SEARCH */}
        <motion.div
          className="search-wrap"
          variants={fadeUp}
          whileHover={{
            y: -2,
          }}
          transition={{
            duration: 0.3,
          }}
        >

          <motion.input
            type="text"
            value={searchTerm}
  onChange={(e) =>
    setSearchTerm(e.target.value)
  }
            whileFocus={{
              scale: 1.01,
            }}
            transition={{
              duration: 0.25,
            }}
          />
          {filteredServices.length > 0 && (

  <div className="search-dropdown">
{filteredServices.map((service) => (
  <div
    key={`${service.location}-${service.slug}`}
    className="search-dropdown-item"
    onClick={() => {
      navigate(service.path);
      setSearchTerm("");
    }}
  >
    <span className="search-service-title">
      {service.title} {""}
    </span>

    {service.location && (
      <span className="search-service-location">
        {` - ${service.location} `}
      </span>
    )}
  </div>
))}

  </div>

)}

          <motion.button
         onClick={() => {
  if (filteredServices.length > 0) {
    navigate(filteredServices[0].path);
    setSearchTerm("");
  }
}}
            whileTap={{
              scale: 0.97,
            }}
            transition={{
              duration: 0.28,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            Find Services
          </motion.button>

        </motion.div>

        {/* SUBURBS */}
        <motion.div
          className="popular-suburbs"
          variants={fadeUp}
        >

          <motion.span
            className="popular-label"
            initial={{
              opacity: 0,
            }}
            whileInView={{
              opacity: 1,
            }}
            transition={{
              duration: 0.6,
            }}
            viewport={{
              once: true,
            }}
          >
            Popular suburbs :
          </motion.span>

          {suburbs.map((suburb, index) => (
  <motion.span
    key={suburb.name}
    custom={index}
    variants={suburbVariant}
    whileHover={
      suburb.link
        ? {
            y: -2,
            opacity: 0.75,
          }
        : {}
    }
    transition={{
      duration: 0.22,
    }}
    className={suburb.link ? "suburb-link" : "suburb-disabled"}
    onClick={() => {
      if (suburb.link) {
        navigate(suburb.link);
      }
    }}
  >
    {suburb.name}
  </motion.span>
))}

          {/*<motion.a
            href="/"
            initial={{
              opacity: 0,
              x: -12,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
            }}
            transition={{
              delay: 0.5,
              duration: 0.6,
              ease: [0.22, 1, 0.36, 1],
            }}
            viewport={{
              once: true,
            }}
            whileHover={{
              x: 4,
            }}
          >
            View all
          </motion.a>*/}

        </motion.div>

      </motion.div>
    </section>
  );
};

export default SearchSection;